import { z } from "zod";

export const accountSettings = z.object({
  acceptsEmail: z.boolean().optional(),
  acceptsSms: z.boolean().optional(),
});

export type AccountSettings = z.infer<typeof accountSettings>;
